
export const portfolioActionTypes = {
	/**
	 * Portfolio (analytics-related) action types
	 */
	COLLAPSE_MEDIA_LIST         : "PORTFOLIO_COLLAPSE_MEDIA_LIST",
	EXPAND_MEDIA_LIST           : "PORTFOLIO_EXPAND_MEDIA_LIST",
	COPY_URL                    : "PORTFOLIO_COPY_URL",
	SOURCE_RENAME_TITLE_START   : "PORTFOLIO_SOURCE_RENAME_TITLE_START",
	SOURCE_RENAME_TITLE_CANCEL  : "PORTFOLIO_SOURCE_RENAME_TITLE_CANCEL",
	SOURCE_RENAME_TITLE_SUCCESS : "PORTFOLIO_SOURCE_RENAME_TITLE_SUCCESS",
};